import { Input } from 'antd';
import React from 'react';

const InputComponent = (props) => {
  const { onChange, ...rest } = props;

  const handleChange = (e) => {
    const value = e.target.value;
    if (typeof onChange === 'function') {
      onChange(e);
    } else {
      onChange(value);
    }
  };

  return (
    <Input
      maxLength={1500}
      {...rest}
      onChange={handleChange}
    />
  );
};

export default InputComponent;
